import { Component, ViewChild, ElementRef } from "@angular/core";
import { ProjectData } from "./entities/project-data.entity";
import { Subscription } from "rxjs";
import { Router, NavigationEnd } from "@angular/router";
import { ModelService } from "./services/model.service";
import { LoginService } from "./login/login_service/login.service";
import { UserListService } from "./admin/user-list/user-list.service";
import { ConfigService } from "./app.config";
import { Utils } from "./utils.module";

import { Store } from "@ngrx/store";
import * as pathActions from "./store/path/path.actions";
import { AppState } from "./app.reducers";
import { MODE } from "./builder/bulder-datas";
import { BuilderService } from "./builder/builder.service";
import { CleanPerimeters } from "./utils/clean-perimeters";
import { AlertData } from "./alert/alert-data.entity";
import { AlertComponent } from "./alert/alert.component";

// ESPRRIVISA-131
import { LoggerService } from "./services/logger.service";

declare let ga: (p1?: any, p2?: any, p3?: any) => {};

@Component({
	selector: "app-root",
	templateUrl: "./app.component.html",
	styleUrls: ["./app.component.scss"],
})
export class AppComponent {
	@ViewChild("alertWindow") alertWindow: AlertComponent;

	// Arreglo de subscribes, utilizado para liberarlos todos al mismo tiempo.
	private subscriptions: Subscription[] = [];

	public projectData: ProjectData;
	private userUpdatedSubs: Subscription;
	private userLogoutSubs: Subscription;

	public currentDrawing = MODE.DRAG;

	// Store Redux
	private path = "";
	public _testeo = "";

	constructor(
		private builderService: BuilderService,
		private store: Store<AppState>,
		public router: Router,
		public modelService: ModelService,
		private loginService: LoginService,
		private userListService: UserListService,
		private viewRef: ElementRef,
		// ESPRRIVISA-131
		public loggerService: LoggerService
	) {
		const self = this;
		this.modelService
			.getLanguage()
			.setLanguage(
				localStorage.getItem("language") || ConfigService.DEFAULT_LANG
			);
		const imgId =
			this.projectData && this.projectData.userId
				? this.projectData.userId
				: "";
	}

	public ngOnInit() {
		// ESPRRIVISA-131
		LoggerService.showTrace();
		LoggerService.showDebug();
		LoggerService.showInfo();
		LoggerService.showWarn();
		// LoggerService.showError();
		// LoggerService.showFatal();

		this.loginService.isLoggedIn();
		// reset de scroll en cambio de pagina

		this.store.subscribe((state) => {
			this.path = state.uiPath.path;
			this.currentDrawing = state.builder.currentDrawing;
		});

		this.router.events.subscribe((evt) => {
			if (!(evt instanceof NavigationEnd)) return;
			window.scrollTo(0, 0);
			if (this.router.url.includes("/scheme")) {
				this.projectData = JSON.parse(
					localStorage.getItem(Utils.CURRENT_PROJECT)
				);
				if (!this.projectData) {
					this.projectData = new ProjectData();
				} else {
					//let newVersion = new ParseProjectVersion();
					//this.projectData = newVersion.parse(this.projectData);
				}
			} else if (this.router.url.includes("/satelite")) {
				this.projectData = JSON.parse(
					localStorage.getItem(Utils.CURRENT_PROJECT)
				);
				if (!this.projectData) {
					this.projectData = new ProjectData();
				}
			}

			if (evt instanceof NavigationEnd) {
				ga("set", "page", evt.urlAfterRedirects);
				ga("send", "pageview");
			}
		});

		// Menú en los editores, fue eliminado.
		//this.subscriptions.push(this.modelService.closeMenuContextEditors.subscribe((value: any) => { this.menu Open = false; }));

		//this.projectData = JSON.parse(localStorage.getItem(Utils.CURRENT_PROJECT));

		// TODO limpiar project del localstorage
		this.router.navigate(["/hold"]);
	}

	// La barra superior no se muestra cuando está en hold.
	public showBar = () => !this.router.url.includes("/hold");

	// public showBar(): boolean {
	// 	return !(this.router.url.includes('/hold'));
	// }

	// Se pulsa en el icono superior izquierda para navegar hacia atrás.
	public onReturn() {
		this.router.navigate([this.path]);
		this.store.dispatch(pathActions.goBack());
	}
	// Volver a la home incondicionalmente.
	public onReturnHome() {
		const project = JSON.parse(localStorage.getItem(Utils.CURRENT_PROJECT));

		// El proyecto debe existir.
		if (project && project.perimetro) {
			// Comprobar nombre, no debería cumplir error.
			let nombre = project.nombre.trim();
			if (nombre !== "") {
				project.nombre = nombre;
			} else {
				// Error, avisar para que renombre el proyecto.
				const data: AlertData = new AlertData();
				data.title = this.modelService.getString("Home_NoName_title");
				data.message = this.modelService.getString("Home_NoName_body");
				this.alertWindow.show(data);
				return; // No cambiar de pantalla.
			}

			// Útil para escanear proyectos.
			const clean = new CleanPerimeters();
			// En esquema se comprueba si se superponen poste.
			if (project.renderer === Utils.SCHEME2) {
				project.perimetro = clean.clean(project.perimetro);
			}

			// Para esquema y satélite se comprueba que tengan el producto seleccionado.
			if (project.perimetro.length > 0) {
				if (!clean.exsitsProducts(project)) {
					const data: AlertData = new AlertData();
					data.title =
						this.modelService.getString("Home_NoDatas_title");
					data.message =
						this.modelService.getString("Home_NoDatas_body");
					this.alertWindow.show(data);
					return;
				}
			}

			// Comprobar que tiene perímetros.
			if (project.perimetro.length === 0) {
				// Avisar que el proyecto no tiene perímetros.
				const data: AlertData = new AlertData();
				data.title = this.modelService.getString(
					"Home_NoPerimeters_title"
				);
				data.messages = this.modelService
					.getString("Home_NoPerimeters_body")
					.split("#");
				data.type = "modal";
				this.alertWindow.show(data);

				const subWindow = this.modelService.alertResultSignal.subscribe(
					(shouldRemove: boolean) => {
						subWindow.unsubscribe();
						this.alertWindow.close();
						if (shouldRemove) {
							//sin save
							this.router.navigate(["/hold"]);
							this.store.dispatch(pathActions.home());
							if (this.projectData.renderer === Utils.SCHEME2)
								this.modelService.squemaGoToHomeSignal.emit(
									true
								);
							return;
						}
					}
				);
				return;
			} else {
				// Guardar info proyecto
				localStorage.setItem(
					Utils.CURRENT_PROJECT,
					JSON.stringify(project)
				);
				this.builderService.saveProject(project).subscribe(
					(result) => {
						if (project._id === "" && result._id)
							project._id = result._id;
						localStorage.setItem(
							Utils.CURRENT_PROJECT,
							JSON.stringify(project)
						);
						const _his = this.userListService
							.historyProjects(
								project._id,
								project.nombre,
								project.renderer,
								this.modelService.getUser().getData()
							)
							.subscribe(() => {
								_his.unsubscribe();
							});
					},
					(error) => {
						console.log(error);
					}
				);
			}
		}
		this.router.navigate(["/hold"]);
		this.store.dispatch(pathActions.home());
		this.store.dispatch(pathActions.iDontComingFrom3D());
		if (this.projectData.renderer === Utils.SCHEME2)
			this.modelService.squemaGoToHomeSignal.emit(true);
	}

	// public onMenu() { this.men Open = !this.menu Open; }

	public ngOnDestroy() {
		this.userLogoutSubs.unsubscribe();
		this.userUpdatedSubs.unsubscribe();
		this.subscriptions.map((item: Subscription) => {
			item.unsubscribe();
		});
	}

	public onKillFocus(event): void {
		this.modelService.saveProjectSignal.emit(this.projectData);
	}

	public getTitulo() {
		return this.projectData && this.projectData.nombre
			? this.projectData.nombre
			: "";
	}

	public proyectoBorrador(): boolean {
		return (
			this.projectData &&
			this.projectData.estado === 0 &&
			this.projectData.nombre !== ""
		);
	}

	// Menú en los editores, fue anulado.
	// public showMenu(): boolean { return (this.router.url.includes('/scheme') || this.router.url.includes('/satelite')) && this.menu Open; }

	public showTitleProject(): boolean {
		return (
			this.router.url.includes("/scheme") ||
			this.router.url.includes("/satelite") ||
			this.path.includes("/scheme") ||
			this.path.includes("/satelite")
		);
	}

	// El botón de retorno no sale en los editores (sale el botón de menú), en login no debe salir
	public showReturn(): boolean {
		return !(
			this.router.url.includes("/login") ||
			this.router.url.includes("/scheme") ||
			this.router.url.includes("/satelite") ||
			this.path.includes("/scheme") ||
			this.path.includes("/satelite")
		);
	}

	// ### Habilita o deshabilita las opciones de ver presupuesto y cambiar de view 2D/3D.center			MVC
	public get readyForRender(): boolean {
		this.projectData = JSON.parse(
			localStorage.getItem(Utils.CURRENT_PROJECT)
		);
		const rs: any[] =
			this.projectData.perimetro &&
			this.projectData.perimetro.length > 0 &&
			this.currentDrawing !== MODE.DRAW &&
			this.projectData.perimetro.filter((perimetro) => {
				return (
					perimetro === undefined ||
					perimetro.producto === undefined ||
					perimetro.producto.panel === undefined ||
					perimetro.puertas.filter((puerta) => {
						return puerta.puerta === undefined;
					}).length > 0
				);
			});
		return rs.length === 0;
	}

	public sendForAproval() {
		// Menú en los editores, fue eliminado. //this.menu Open = false;
		if (this.router.url.includes("/scheme")) {
			// Almacena dirección de retorno.
			this.store.dispatch(pathActions.goFront({ path: "/scheme" }));
			//if (document.location.origin.includes('localhost:7890')) return;
			this.modelService.sendForAprovalSqueme.emit("");
		} else {
			// Almacena dirección de retorno.
			this.store.dispatch(pathActions.goFront({ path: "/satelite" }));
			//if (document.location.origin.includes('localhost:7890')) return;
			this.modelService.sendForAprovalSatelite.emit("");
		}
	}
}
